<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :routeBack="this.$store.getters.isAdmin ? 'Dashboard' : 'UserIndex'" :title="user.tostring"/>
        <show-actions
          :deleteItem=allowDelete
          :editItem=allowEdit
          :resetPassword=allowResetPassword
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnResetPasswordBtn="clickOnResetPasswordBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div v-if="isAdmin" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.personal.infos') }}
                </span>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Firstname') }}
                </div>
                <div class="mt-2">
                  {{ getValue("firstname") }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Lastname') }}
                </div>
                <div class="mt-2">
                  {{ getValue("lastname") }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Username') }}
                </div>
                <div class="mt-2">
                  {{ getValue("username") }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text ">
                  {{ $t('user.PhoneNumber') }}
                </div>
                <div class="mt-2">
                  {{ getValue("phoneNumber") }}
                </div>
              </div>


              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Password') }}
                </div>
                <div class="mt-2">
                  <a class="cursor-pointer" @click="clickOnResetPasswordBtn">Réinitialiser le mot de passe</a>
                </div>
              </div>

              <div v-if="isAdmin" class="col-12 col-md-12 col-lg-12 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Comment') }}
                </div>
                <div v-if="commentaire" class="mt-2 col-12">
                  <p v-html="commentaire"></p>
                </div>
                <div v-else class="mt-2">
                  <p>{{ "N/A" }}</p>
                </div>
              </div>

              <div v-if="!isAdmin" class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text ">
                  {{ $t('role.enum.type.collaborator') }}
                </div>
                <div class="mt-2">
                  {{ $t(getValue("role")) }}
                </div>
                <div class="mt-2">
                  {{ $t('role.enum.' + getValue("role") + '.explication') }}
                </div>
              </div>
            </div>

            <div v-if="isAdmin && user.subscriptionType !== 'COLLABORATOR'" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.entreprise.infos') }}
                </span>
            </div>

            <div v-if="isAdmin && user.subscriptionType !== 'COLLABORATOR'" class="row">
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Entreprise') }}
                </div>
                <div class="mt-2">
                  {{ getValue("entreprise") }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Address') }}
                </div>
                <div class="mt-2">
                  {{ getValue("address") }}
                </div>
              </div>

              <div class="col-12 col-md-1 col-lg-1 mb-4">
                <div class="bold-text ">
                  {{ $t('user.PostalCode') }}
                </div>
                <div class="mt-2">
                  {{ getValue("postalCode") }}
                </div>
              </div>

              <div class="col-12 col-md-3 col-lg-3 mb-4">
                <div class="bold-text ">
                  {{ $t('user.City') }}
                </div>
                <div class="mt-2">
                  {{ getValue("city") }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.CapitalSocial') }}
                </div>
                <div class="mt-2">
                  {{ getValue("capitalSocial") }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Siret') }}
                </div>
                <div class="mt-2">
                  {{ getValue("siret") }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Rcs') }}
                </div>
                <div class="mt-2">
                  {{ getValue("rcs") }}
                </div>
              </div>
            </div>

            <div v-if="isAdmin && user.subscriptionType !== 'COLLABORATOR' && listEntreprises.length > 0" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.entreprise.others') }}
                </span>
            </div>

            <div v-for="(entreprise, index) in listEntreprises" v-if="isAdmin && user.subscriptionType !== 'COLLABORATOR' && listEntreprises.length > 0" class="row">

              <hr v-if="index>0" class="col-md-11 mx-4">

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Entreprise') }}
                </div>
                <div class="mt-2">
                  {{ entreprise.entreprise }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Address') }}
                </div>
                <div class="mt-2">
                  {{ entreprise.address }}
                </div>
              </div>

              <div class="col-12 col-md-1 col-lg-1 mb-4">
                <div class="bold-text ">
                  {{ $t('user.PostalCode') }}
                </div>
                <div class="mt-2">
                  {{ entreprise.postalCode }}
                </div>
              </div>

              <div class="col-12 col-md-3 col-lg-3 mb-4">
                <div class="bold-text ">
                  {{ $t('user.City') }}
                </div>
                <div class="mt-2">
                  {{ entreprise.city }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.CapitalSocial') }}
                </div>
                <div class="mt-2">
                  {{ entreprise.capitalSocial }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Siret') }}
                </div>
                <div class="mt-2">
                  {{ entreprise.siret }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Rcs') }}
                </div>
                <div class="mt-2">
                  {{ entreprise.rcs }}
                </div>
              </div>

            </div>

          </b-card>

          <b-card v-if="isAdmin && user.subscriptionType !== 'COLLABORATOR'" class="shadow-sm">
            <div class="row d-flex flex-row justify-content-between align-items-center">
              <div v-b-toggle.history class="col-8 bold-text level-two-title my-2 main-color">
                {{ $t('user.abonnements.history') }}
              </div>
              <div v-b-toggle.history class="mx-3">
                <caret-down-icon></caret-down-icon>
              </div>
            </div>

            <!-- Collapsible part -->
            <b-collapse id="history" class="row flex-row align-items-end">
              <template v-for="(abonnement, index) in abonnements">
                <div class="col-md-2">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ $t('user.abonnement.premium.type') }}</div>
                    <div> {{ $t(abonnement.subscriptionType.text) }}</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ $t('user.abonnement.debut') }}</div>
                    <div> {{ abonnement.startDate }}</div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ $t('user.abonnement.fin') }}</div>
                    <div> {{ abonnement.endDate }}</div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ $t('user.abonnement.maxNbCollaborators') }}</div>
                    <div> {{ abonnement.maxNbCollaborators + " (+" + (abonnement.maxNbCollaborators - abonnement.subscriptionType.maxNbCollaborators)+")" }}</div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ $t('user.abonnement.maxNbOperations') }}</div>
                    <div> {{ abonnement.maxNbOperations + " (+" + (abonnement.maxNbOperations - abonnement.subscriptionType.maxNbOperations)+")" }}</div>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ $t('user.abonnement.type') }}</div>
                    <div> {{ $t('user.Payment.' + user.subscriptionType) }}</div>
                  </div>
                </div>

                <div v-if="index < abonnements.length - 1" class="row">
                  <div class="horizontal-line-main-color"></div>
                </div>
              </template>
            </b-collapse>
          </b-card>


        </div>

      </div>

    </b-container>

    <!-- Modal Delete -->
    <Item-delete-modal
      :itemSingularName="this.$store.getters.isAdmin? 'client': 'collaborator'"
      :selectedItem="user"
      :selectedItemSpecialString="user.username"
      controllerName="user"
      itemSingularNameUpp="User"
      @didDeleteItem="didDeleteUser()">
    </Item-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import ShowActions from '../../components/b122/ShowActions'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'UserShow',

  components: {
    BackArrow,
    ShowActions,
    ItemDeleteModal
  },

  data() {
    return {
      isAdmin: this.$store.getters.isAdmin,
      allowDelete: true,
      allowResetPassword: true,
      allowEdit: true,
      userId: this.$route.params.userId,
      user: {},
      abonnements: [],
      listEntreprises: [],
      commentaire: null
    }
  },

  computed: {
    getValue() {
      return property => (this.user[property] || this.user[property] === false) ? this.user[property] : 'N/A'
    },
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchUser()
      this.fetchAbonnements()
      this.getCommentaireAdmin()
      this.getListEntreprises()
    },

    fetchUser() {
      api
        .get(`/user/${this.userId}`)
        .then(response => {
          this.user = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'UserIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async getCommentaireAdmin() {
      if (this.isAdmin) {
        await api
          .get(`/user/getCommentUser/${this.userId}`)
          .then(response => {
            this.commentaire = response.data.comment
          })
      }
    },

    async getListEntreprises() {
      if (this.isAdmin) {
        await api
          .get(`/user/getListEntreprises/${this.userId}`)
          .then(response => {
            this.listEntreprises = response.data
          })
      }
    },

    fetchAbonnements() {
      api
        .get(`/user/getAbonnementsByUser/${this.userId}`)
        .then(response => {
          response.data.forEach(abonnement => {
            this.abonnements.push({
              id: abonnement.id,
              startDate: new Date(abonnement.debut).toLocaleDateString().split("/").join("/"),
              endDate: new Date(abonnement.fin).toLocaleDateString().split("/").join("/"),
              subscriptionType: abonnement.premiumSubscriptionType,
              maxNbCollaborators: abonnement.maxNbCollaborators,
              maxNbOperations: abonnement.maxNbOperations
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'UserIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    clickOnResetPasswordBtn() {
      const formData = new FormData()
      formData.append('username', this.user.username)

      this.$confirm(this.$t('reset.password.confirm'), this.$t('forgotTitle')).then(() => {
        api({
          method: 'POST',
          url: `/forgotPassword/sendResetPasswordMail`,
          data: formData
        })
          .then(() => {
            this.successToast(this.$i18n.t('Reset.password.mail.sent') + ' "' + this.user.username + '" ')
          })
      });

    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: this.user.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteUser() {
      this.$router.push({
        name: 'UserIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast((this.$store.getters.isAdmin ? this.$i18n.t('Client') : this.$i18n.t('Collaborator')) + ' "' + this.user.username + '" ' + this.$i18n.t('deleted'))
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserShow.vue